import classNames from 'classnames';
import equal from 'fast-deep-equal/react';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeVisiblePopup } from '~/Actions/ActionApp';
import { State } from '~/Reducers';
import { openCategoryByName } from '~/utils/category';
import { t } from '~/utils/localization';
import { settings } from '~/utils/settings';
import styles from './EventumCnRedirectButton.scss';

interface IEventumCnRedirectButton {
    withIcon?: boolean;
    className?: string;
}

interface IStateSelector {
    categories: ICategories;
    popupActive: IPopup;
}

const stateSelector = (state: State): IStateSelector => {
    return {
        categories: state.ReducerApp.categories,
        popupActive: state.ReducerApp.popupActive,
    };
};

const EventumCnRedirectButton = ({ withIcon, className }: IEventumCnRedirectButton) => {
    const dispatch = useDispatch();
    const state = useSelector<State, IStateSelector>(stateSelector, equal);

    const redirect = (event: React.MouseEvent) => {
        event.stopPropagation();
        if (!!state.popupActive) {
            dispatch(changeVisiblePopup(null));
        }
        openCategoryByName(settings.eventumCNCategoryName);
    };

    if (!settings.eventumCNCategoryName || !state.categories?.[settings.eventumCNCategoryName]) {
        return null;
    }

    const classes = classNames(styles.wrapper, className, {
        [styles.withIcon]: withIcon,
    });

    return (
        <div className={classes} onClick={redirect}>
            {t('购买补给兑换券')}
        </div>
    );
};

export default EventumCnRedirectButton;
